export const chooseAppartment = (appartmentId) => ({
    type: 'CHOOSE_APPARTMENT',
    appartmentId
});

export const changeRoom = (appartmentId, roomId) => ({
    type: 'CHANGE_ROOM',
    appartmentId,
    roomId
});

export const back = () => ({
    type: 'BACK'
});

export const hideHand = () => ({
    type: 'HIDE_HAND'
});

export const selectMode360 = () => ({
    type: 'SELECT_MODE_360'
});

export const selectModeVideo = () => ({
    type: 'SELECT_MODE_VIDEO'
});

export const changeVideo = (videoId) => ({
    type: 'CHANGE_VIDEO',
    videoId
});

export const changeTextVideoApp = (line1, line2) => ({
    type: 'CHANGE_TEXTS_VIDEOAPP',
    line1,
    line2
});

export const pageChangeStart = () => ({
    type: 'PAGE_CHANGE_START'
});

export const pageChangeEnd = () => ({
    type: 'PAGE_CHANGE_END'
});



// WEBPACK FOOTER //
// ./src/actions/index.js